exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * jQuery UI Autocomplete 1.13.2\n * http://jqueryui.com\n *\n * Copyright jQuery Foundation and other contributors\n * Released under the MIT license.\n * http://jquery.org/license\n *\n * http://api.jqueryui.com/autocomplete/#theming\n */\n.ui-autocomplete {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tcursor: default;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/abonnal/Dev/jean-louis-david.lan/web/app/themes/jld/node_modules/css-loader!/Users/abonnal/Dev/jean-louis-david.lan/web/app/themes/jld/node_modules/jquery-ui/themes/base/autocomplete.css
// module id = 779
// module chunks = 0